export class FileUpload {
  uploadFile(uploader: any, fileReference: any) {
    uploader.clearQueue();
    if (fileReference && fileReference[0]) {
      fileReference[0].value = '';
    }
    fileReference.click();
  }

  getFile(uploader: any) {
    const { queue = [] } = uploader;

    if (queue && queue.length > 0) {
      const { _file } = queue[0];
      return _file;
    }

    return null;
  }
}



// WEBPACK FOOTER //
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/shared/file-upload/file-upload.ts